import { Avatar, Button, Stack, Typography } from '@mui/material';
import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { ArrowRightWhite } from 'Images';
import { useContext } from 'react';

interface IButtons {
  dispatchReferrals: Function;
  closeAdvancedSearch: Function;
}

export const Buttons = ({
  dispatchReferrals,
  closeAdvancedSearch,
}: IButtons) => {
  const isDesktop = useIsDesktop();
  const dictionary =
    Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch;

  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap={isDesktop ? '56px' : 0}
      justifyContent={isDesktop ? 'flex-end' : 'space-between'}
    >
      <Button
        onClick={() => {
          dispatchAdvancedSearch({ type: 'RESET' });
          dispatchReferrals({ type: 'RESET' });
        }}
        variant='textBtn'
        sx={{
          width: 'fit-content',
          textUnderlineOffset: '3px',
        }}
        aria-label={dictionary.ariaLabelRest}
      >
        <Typography
          fontWeight={700}
          color='primary.main'
          fontSize={isDesktop ? '20px' : '18px'}
        >
          {dictionary.reset}
        </Typography>
      </Button>
      <Button
        variant='primary'
        sx={{
          whiteSpace: 'nowrap',
          fontWeight: 700,
          fontSize: isDesktop ? '20px' : '18px',
          padding: isDesktop ? '6px 60px' : '6px 40px',
        }}
        onClick={() => {
          if (
            advancedSearch.requestNumber &&
            advancedSearch.requestNumber.toString().length < 4
          )
            return;
          dispatchReferrals({
            type: 'ADVANCED_SEARCH',
            payload: { value: advancedSearch },
          });
          dispatchAdvancedSearch({
            type: 'ACTIVE_SEARCH_ADVANCED',
            payload: { value: true },
          });
          closeAdvancedSearch(false);
        }}
      >
        <Typography variant={'body4'} color={'#fff'}>
          {dictionary.showResults}
        </Typography>
        <Avatar
          alt={''}
          src={ArrowRightWhite}
          sx={{ width: '20px', height: '20px' }}
        />
      </Button>
    </Stack>
  );
};
